import i18n from "shared/i18n";

/**
 * A higher-order function that provides translation functions to the wrapped function.
 * @param {string|string[]} ns - The namespace(s) to load translations from.
 * @param {Function} func - The function to be wrapped, which will receive the translation function.
 * @returns {Function} An asynchronous function that loads the specified namespace(s) and provides the translation function to the wrapped function.
 */
export function withTranslationsV2(ns, func) {
  /**
   * Asynchronous function that loads translations and provides a translation function.
   *
   * @param {...any} args - Arguments passed to the original function.
   * @returns {Promise<any>} - The result of the original function with translations applied.
   */
  return async (...args) => {
    await i18n.loadNamespaces(ns);
    const t = i18n.getFixedT(null, ns);
    return func(t, ...args);
  };
}
